<h3 mat-dialog-title>{{ 'Verify your Stripe account' }}</h3>
<img (click)="close()" class="mat-close" src="/assets/images/payhoa/other/icon_close.svg">

<mat-dialog-content>
    <div *ngIf="loading$ | async" class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
        <p>{{ 'Loading verification form...' }}</p>
    </div>

    <div #stripeContainer
         class="stripe-container"
         [class.hidden]="loading$ | async">
    </div>
</mat-dialog-content>
